// extracted by mini-css-extract-plugin
export default {"widget":"DailyWidget_widget__UQetx","left":"DailyWidget_left__LF4CZ","title":"DailyWidget_title__39lAq","tasks":"DailyWidget_tasks__krq6E"};